import { render, staticRenderFns } from "./PrestaCard.vue?vue&type=template&id=a42e5312&scoped=true"
import script from "./PrestaCard.vue?vue&type=script&lang=js"
export * from "./PrestaCard.vue?vue&type=script&lang=js"
import style0 from "./PrestaCard.vue?vue&type=style&index=0&id=a42e5312&prod&lang=stylus&scoped=true"
import style1 from "./PrestaCard.vue?vue&type=style&index=1&id=a42e5312&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42e5312",
  null
  
)

export default component.exports